import styled from 'styled-components/macro';
import React, { useContext } from 'react';
import ThemeContext from '../utils/theming';

export const LoadingSpinnerContainer = styled.div`
    &:before {
        content: '';
        box-sizing: border-box;
        position: absolute;
        top: 50%;
        left: 50%;
        width: ${props => (props.width ? props.width : 30)}px;
        height: ${props => (props.width ? props.height : 30)}px;
        margin-top: -${props => (props.height ? props.height / 2 : 15)}px;
        margin-left: -${props => (props.width ? props.width / 2 : 15)}px;
        border-radius: 50%;
        border: ${props => (props.stroke ? props.stroke : 3)}px solid ${({ theme }) => theme.colors.primary};
        border-top-color: #fff;
        animation: spinner ${props => (props.speed ? props.speed : 0.6)}s linear infinite;
    }

    @keyframes spinner {
        from {
            transform: rotate(0deg);
        }

        to {
            transform: rotate(360deg);
        }
    }
`;

const ThumbnailLoadingSpinnerContainer = styled.div`
    box-sizing: border-box;
    position: absolute;
    width: ${props => (props.width ? props.width : 30)}px;
    height: ${props => (props.width ? props.height : 30)}px;
    border-radius: 50%;
    border: ${props => (props.stroke ? props.stroke : 3)}px solid ${({ theme }) => theme.colors.primary};
    border-top-color: #fff;
    animation: spinner ${props => (props.speed ? props.speed : 0.6)}s linear infinite;

    @keyframes spinner {
        from {
            transform: rotate(0deg);
        }

        to {
            transform: rotate(360deg);
        }
    }
`;

export const LoadingSpinner = props => (<LoadingSpinnerContainer {...props} theme={useContext(ThemeContext)} />)
export const ThumbnailLoadingSpinner = props => (<ThumbnailLoadingSpinnerContainer {...props} theme={useContext(ThemeContext)} />)
